var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZenytLogoWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 75,
    viewBox: "0 0 351 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.74 45.3881H289.771L298.361 11.8197H312.473L295.381 74.3119H281.183L286.091 57.2211H285.609C279.64 57.2211 274.416 53.2064 272.879 47.4379L263.39 11.8197H277.501L285.74 45.3881ZM180.813 10.7679C185.371 10.7679 189.491 11.7608 193.172 13.7474C196.911 15.7341 199.862 18.5977 202.024 22.3373C204.245 26.0768 205.354 30.4589 205.354 35.4838V38.5521H170.296C170.939 41.2398 172.166 43.3141 173.978 44.7748C175.789 46.177 178.097 46.8783 180.901 46.8783C183.18 46.8783 185.079 46.4982 186.599 45.7386C188.118 44.979 189.374 43.8398 190.367 42.3207H204.391C203.105 47.112 200.271 50.9685 195.889 53.89C191.565 56.8115 186.54 58.2728 180.813 58.2728C176.197 58.2728 171.99 57.2496 168.192 55.2045C164.453 53.101 161.502 50.2382 159.34 46.6156C157.178 42.9928 156.097 38.9607 156.097 34.5199C156.097 30.0208 157.178 25.9599 159.34 22.3373C161.502 18.7145 164.453 15.8804 168.192 13.8353C171.99 11.7902 176.197 10.768 180.813 10.7679ZM151.055 12.4564C151.055 20.4729 147.405 28.0535 141.139 33.0531L126.776 44.5121V45.8265H151.668V57.2211H111V56.5551C111 48.5549 114.635 40.9881 120.88 35.9877L135.19 24.5287V23.2142H112.14V11.8197H151.055V12.4564ZM241.647 10.7679C246.906 10.768 251.026 12.404 254.006 15.6761C257.044 18.9483 258.563 23.5935 258.563 29.6117V57.2201H244.891V31.8031C244.891 29.057 244.189 26.9239 242.787 25.4047C241.385 23.8271 239.369 23.0385 236.739 23.0385C233.935 23.0385 231.597 23.9734 229.728 25.8431C227.858 27.6545 226.923 29.9623 226.923 32.767V57.2201H213.25V11.8197H226.134V18.3929H226.572C227.858 16.231 229.785 14.4191 232.356 12.9584C234.986 11.4976 238.083 10.7679 241.647 10.7679ZM337.381 12.5199H348.337V23.476H337.381V45.3881H350.528V57.2201H336.883C329.607 57.2201 323.708 51.3221 323.708 44.0463V23.476H314.505V20.7543C314.505 16.2068 318.192 12.5199 322.739 12.5199H323.708V0.687866H337.381V12.5199ZM180.901 22.1615C178.214 22.1615 175.964 22.8333 174.152 24.1771C172.399 25.4626 171.173 27.3334 170.472 29.7875H191.243C190.6 27.3918 189.374 25.521 187.562 24.1771C185.751 22.8333 183.531 22.1615 180.901 22.1615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_85_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5422 21.7609C59.0141 24.5761 51.0902 26.1028 43.8953 27.3759C36.3841 28.7049 27.4495 29.6734 25.9077 26.3549C23.578 21.3407 35.1568 1.84677 42.0964 0.0651001C46.4646 -1.05642 57.0004 12.5611 58.5422 21.7609Z",
    fill: "#C7CBE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 44.4701C20.4169 36.5578 28.4301 34.8079 34.9015 33.4931C35.6149 33.3481 36.3392 33.1991 37.0704 33.0486L37.0737 33.0479C47.9303 30.8141 60.3216 28.2645 61.626 34.0028C63.1847 40.8598 33.4868 59.0254 21.6851 66.2442C19.867 67.3562 18.4736 68.2085 17.6847 68.7197C11.7745 72.5487 4.30537 77.0046 0.468011 71.0171C-2.14887 66.9339 6.73471 53.5342 14.04 44.4701Z",
    fill: "#C7CBE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2826 56.6883C39.0114 61.5836 31.5748 65.985 28.4763 69.2339C26.8956 70.8914 28.7396 74.3225 35.9287 74.6116C36.1954 74.6223 36.4821 74.6341 36.7877 74.6466C43.2001 74.9095 57.9273 75.5134 70.8762 74.0841C80.1267 73.063 88.8638 70.238 83.2106 60.2994C76.4205 48.3622 73.188 46.5372 70.8762 46.274C66.4607 45.7713 57.9807 50.3411 49.8049 55.194C48.958 55.6967 48.1161 56.195 47.2826 56.6883Z",
    fill: "#C7CBE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5422 21.7609C59.0141 24.5761 51.0902 26.1028 43.8953 27.3759C36.3841 28.7049 27.4495 29.6734 25.9077 26.3549C23.578 21.3407 35.1568 1.84677 42.0964 0.0651001C46.4646 -1.05642 57.0004 12.5611 58.5422 21.7609Z",
    fill: "url(#paint0_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 44.4701C20.4169 36.5578 28.4301 34.8079 34.9015 33.4931C35.6149 33.3481 36.3392 33.1991 37.0704 33.0486L37.0737 33.0479C47.9303 30.8141 60.3216 28.2645 61.626 34.0028C63.1847 40.8598 33.4868 59.0254 21.6851 66.2442C19.867 67.3562 18.4736 68.2085 17.6847 68.7197C11.7745 72.5487 4.30537 77.0046 0.468011 71.0171C-2.14887 66.9339 6.73471 53.5342 14.04 44.4701Z",
    fill: "url(#paint1_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2826 56.6883C39.0114 61.5836 31.5748 65.985 28.4763 69.2339C26.8956 70.8914 28.7396 74.3225 35.9287 74.6116C36.1954 74.6223 36.4821 74.6341 36.7877 74.6466C43.2001 74.9095 57.9273 75.5134 70.8762 74.0841C80.1267 73.063 88.8638 70.238 83.2106 60.2994C76.4205 48.3622 73.188 46.5372 70.8762 46.274C66.4607 45.7713 57.9807 50.3411 49.8049 55.194C48.958 55.6967 48.1161 56.195 47.2826 56.6883Z",
    fill: "url(#paint2_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5422 21.7609C59.0141 24.5761 51.0902 26.1028 43.8953 27.3759C36.3841 28.7049 27.4495 29.6734 25.9077 26.3549C23.578 21.3407 35.1568 1.84677 42.0964 0.0651001C46.4646 -1.05642 57.0004 12.5611 58.5422 21.7609Z",
    fill: "url(#paint3_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 44.4701C20.4169 36.5578 28.4301 34.8079 34.9015 33.4931C35.6149 33.3481 36.3392 33.1991 37.0704 33.0486L37.0737 33.0479C47.9303 30.8141 60.3216 28.2645 61.626 34.0028C63.1847 40.8598 33.4868 59.0254 21.6851 66.2442C19.867 67.3562 18.4736 68.2085 17.6847 68.7197C11.7745 72.5487 4.30537 77.0046 0.468011 71.0171C-2.14887 66.9339 6.73471 53.5342 14.04 44.4701Z",
    fill: "url(#paint4_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2826 56.6883C39.0114 61.5836 31.5748 65.985 28.4763 69.2339C26.8956 70.8914 28.7396 74.3225 35.9287 74.6116C36.1954 74.6223 36.4821 74.6341 36.7877 74.6466C43.2001 74.9095 57.9273 75.5134 70.8762 74.0841C80.1267 73.063 88.8638 70.238 83.2106 60.2994C76.4205 48.3622 73.188 46.5372 70.8762 46.274C66.4607 45.7713 57.9807 50.3411 49.8049 55.194C48.958 55.6967 48.1161 56.195 47.2826 56.6883Z",
    fill: "url(#paint5_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5422 21.7609C59.0141 24.5761 51.0902 26.1028 43.8953 27.3759C36.3841 28.7049 27.4495 29.6734 25.9077 26.3549C23.578 21.3407 35.1568 1.84677 42.0964 0.0651001C46.4646 -1.05642 57.0004 12.5611 58.5422 21.7609Z",
    fill: "url(#paint6_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 44.4701C20.4169 36.5578 28.4301 34.8079 34.9015 33.4931C35.6149 33.3481 36.3392 33.1991 37.0704 33.0486L37.0737 33.0479C47.9303 30.8141 60.3216 28.2645 61.626 34.0028C63.1847 40.8598 33.4868 59.0254 21.6851 66.2442C19.867 67.3562 18.4736 68.2085 17.6847 68.7197C11.7745 72.5487 4.30537 77.0046 0.468011 71.0171C-2.14887 66.9339 6.73471 53.5342 14.04 44.4701Z",
    fill: "url(#paint7_linear_85_121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2826 56.6883C39.0114 61.5836 31.5748 65.985 28.4763 69.2339C26.8956 70.8914 28.7396 74.3225 35.9287 74.6116C36.1954 74.6223 36.4821 74.6341 36.7877 74.6466C43.2001 74.9095 57.9273 75.5134 70.8762 74.0841C80.1267 73.063 88.8638 70.238 83.2106 60.2994C76.4205 48.3622 73.188 46.5372 70.8762 46.274C66.4607 45.7713 57.9807 50.3411 49.8049 55.194C48.958 55.6967 48.1161 56.195 47.2826 56.6883Z",
    fill: "url(#paint8_linear_85_121)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_121",
    x1: 43,
    y1: 3.85023e-7,
    x2: 58.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD4D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85_121",
    x1: 43,
    y1: 3.85023e-7,
    x2: 58.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD4D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_85_121",
    x1: 43,
    y1: 3.85023e-7,
    x2: 58.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD4D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_85_121",
    x1: 33.5,
    y1: 4,
    x2: 83,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6388F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6388F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_85_121",
    x1: 33.5,
    y1: 4,
    x2: 83,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6388F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6388F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_85_121",
    x1: 33.5,
    y1: 4,
    x2: 83,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6388F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6388F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_85_121",
    x1: -11.5,
    y1: 75,
    x2: 23,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD1E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_85_121",
    x1: -11.5,
    y1: 75,
    x2: 23,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD1E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_85_121",
    x1: -11.5,
    y1: 75,
    x2: 23,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD1E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 351,
    height: 75,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_85_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenytLogoWordmark);
export default __webpack_public_path__ + "static/media/zenyt_logo_wordmark.a3e2c0aafd53ca13812a5b45d13be6bd.svg";
export { ForwardRef as ReactComponent };